import {useMediaQuery} from '@vueuse/core';
import type {Ref} from 'vue';

/**
 * Reaktives Flag für „mobile" Viewports (< md, also < 768px – passend zur Tailwind-`md`-Grenze).
 * Wird u. a. genutzt, um Panels (Einstellungen, Transpositionen) auf kleinen Bildschirmen
 * standardmäßig eingeklappt zu starten.
 */
export function useIsMobile(): Ref<boolean> {
  return useMediaQuery('(max-width: 767px)');
}
